import React from 'react'
import { CSSTransition } from 'react-transition-group'
import AnimatedLogo from '@wellbeingxltd/fe-lib/images/dist/logo/AnimatedLogo.gif'
import LogoText from '@wellbeingxltd/fe-lib/images/dist/logo/betterspaceWordmarkWhite.svg'
import './style.scss'

const LoginLoader = () => (
    <div className="loginLoader">
        <CSSTransition
            in
            appear
            timeout={300}
            classNames="fadein"
            exit
        >
            <>
                <img src={AnimatedLogo} className="loginLoaderSpinner" alt="Full screen loading spinner" />
                <img src={LogoText} className="loginLoaderLogo" alt="" />
            </>
        </CSSTransition>
    </div>
)

export default LoginLoader
